"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var js_brand_1 = require("@giphy/js-brand");
var react_1 = __importStar(require("react"));
var useRaf_1 = __importDefault(require("react-use/lib/useRaf"));
var Bar = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    height: 2px;\n    position: absolute;\n    width: 5px;\n    bottom: 0;\n    left: 0;\n    opacity: 0.95;\n"], ["\n    background: ", ";\n    height: 2px;\n    position: absolute;\n    width: 5px;\n    bottom: 0;\n    left: 0;\n    opacity: 0.95;\n"])), js_brand_1.giphyWhite);
var ProgressBar = function (_a) {
    var videoEl = _a.videoEl;
    var _b = react_1.useState(0), progress = _b[0], setProgress = _b[1];
    useRaf_1.default(2147483647, 100);
    var time = (videoEl === null || videoEl === void 0 ? void 0 : videoEl.currentTime) || 0;
    var duration = (videoEl === null || videoEl === void 0 ? void 0 : videoEl.duration) || 0;
    var val = time / duration;
    react_1.useLayoutEffect(function () {
        setProgress(val);
    }, [val, setProgress]);
    var perc = Math.round(progress * 100);
    perc = duration < 10 && perc > 98 ? 100 : perc;
    return react_1.default.createElement(Bar, { style: { width: perc + "%" } });
};
exports.default = ProgressBar;
var templateObject_1;
//# sourceMappingURL=progress-bar.js.map